// src/App.jsx
import React, { useEffect, lazy } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ContactPage from "./Components/ContactPage";
import AboutPage from "./Components/About";
import OptionDetails from "./Components/OptionDetails";

const Home = lazy(() => import("./Components/Home"));
const VehicleFleet = lazy(() => import("./Components/VehicleFleets"));

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
};

function App() {
  return (
    <>
      <ScrollToTop />
        <Routes>
          <Route path="/" element={<main style={{ background: "#111" }}><Home /></main>} />
          <Route path="/vehicle-fleet" element={<main style={{ background: "#fff" }}><VehicleFleet /></main>} />
          <Route path="/contact-us" element={<main style={{ background: "#f5f5f5" }}><ContactPage /></main>} />
          <Route path="/about-us" element={<main style={{ background: "#fff" }}><AboutPage /></main>} />
          <Route path="/options/:id" element={<main style={{ background: "#fff" }}><OptionDetails /></main>} />
          <Route path="/options" element={<main style={{ background: "#fff" }}><OptionDetails /></main>} />
        </Routes>
    </>
  );
}

export default App;
